import { SessionActionTypes } from './types';
import { action } from 'typesafe-actions';
import { BasemapSession } from 'utilities/basemap-session.util';

export const initSession = () => action(SessionActionTypes.SESSION_INIT);

export const setUserSession = (user: any) =>
  action(SessionActionTypes.SET_USER_SESSION, user);

export const setAuthenticated = (value: boolean) =>
  action(SessionActionTypes.SET_AUTHENTICATED, value);

export const setUserName = (username: string) =>
  action(SessionActionTypes.SET_SESSION_USER_NAME, username);

export const setUserOrg = (orgId: number, role: string) =>
  action(SessionActionTypes.SET_SESSION_USER_ORGANISATION, { orgId, role });

export const setIsUserReg = (data: boolean) =>
  action(SessionActionTypes.SET_IS_USER_REG, data);

export const startSession = (value?: number) =>
  action(SessionActionTypes.SESSION_START, value);

export const endSession = () => action(SessionActionTypes.SESSION_END);

export const setScreenSize = (value: string) =>
  action(SessionActionTypes.SET_SCREEN_SIZE, value);

export const setIsFromSwxLocate = (data: boolean) =>
  action(SessionActionTypes.SET_IS_FROM_SWXLOCATE, data);

export const setRedirectPath = (value?: string) =>
  action(SessionActionTypes.SET_REDIRECT_PATH, value);

export const setBasemapSession = (session: BasemapSession | null) =>
  action(SessionActionTypes.SET_BASEMAP_SESSION, session);

export const setPurchasedAuthorisation = (
  authorisation:
    | {
        type: string;
        newBalance: number;
        previousBalance: number;
        expiredAt: string;
      }
    | undefined
) => action(SessionActionTypes.SET_PURCHASED_AUTHORISATION, authorisation);
